<template>
  <div>
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-content">
        <form method="POST" action="/add-staff" id="add_staff_form">
          <input type="hidden" name="_token" v-model="csrfToken">
          <div class="flex-xs">
            <div class="half-width-xs pr-10-xs">
              <div class="form-group">
                <label>Name</label>
                <input type="text" name="name" class="form-control" v-model="user.name" required>
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="text" name="email" class="form-control" v-model="user.email" required>
              </div>
              <div class="form-group">
                <label>Primary Contact Number</label>
                <input type="text" name="phone" class="form-control" required>
              </div>
              <div class="form-group">
                <label>User Type</label>
                <select type="text" name="user_type_id" class="form-control" v-model="user.user_type_id">
                  <option v-for="user_type in user_types" :value="user_type.id"> {{ user_type.label }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Login Type</label>
                <select class="form-control" name="auth_type_id" v-model="user.auth_type_id">
<!--                  <option :value="1">Password Only</option>-->
                  <option :value="2">MFA - Email Code</option>
                  <option :value="3">Azure Login</option>
                </select>
              </div>
            </div>
            <div class="half-width-xs">
            </div>
          </div>
          <div class="align-right mt-3">
            <button class="btn-primary" @click.stop.prevent="save()">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'logged_in_user',
    'epwin_system_types_for_user',
    'user_types',
  ],
  mounted() {
  },
  data() {
    return {
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      saving: false,
      user: {
        user_type_id: 2,
        auth_type_id: 2,
      },
    }
  },
  methods: {
    save() {
      this.saving = true;
      const validationErrors = Validate({
        'User Type': this.user.user_type_id,
        'Login Type': this.user.auth_type_id,
        'Name': this.user.name,
        'Email': this.user.email,
      }, {
        'User Type': {
          presence: {
            allowEmpty: false,
            type: 'number',
          },
        },
        'Login Type': {
          presence: {
            allowEmpty: false,
            type: 'number',
          },
        },
        'Name': {
          presence: {
            allowEmpty: false,
          },
        },
        'Email': {
          presence: {
            allowEmpty: false,
          },
          email: true,
        },
      });

      if (validationErrors) {
        this.saving = false;
        Swal.fire({
          title: 'Unable to create user',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        return;
      }

      document.getElementById('add_staff_form').submit();

    },
  },
};
</script>
